

































































































import { defineComponent, reactive, ref, computed } from '@vue/composition-api';
import { getStore } from '../store';
import { useI18n, getPrivacyPolicyLocalizedUrl } from '../i18n';
import { useClientChecker } from '../client-checker';
import { useRouter } from '../router';

const componentName = 'Consent';

export default defineComponent({
    name: componentName,

    setup(context) {
        const store = getStore(), { router, route } = useRouter(), i18n = useI18n();

        const client = useClientChecker();

        const state = reactive({
            consentInfo: null,
            consentProgress: false,
            form: {
                privacy: false,
            },
        });

        const showConsentScopesCheckboxList = computed(() => {
            return !(client.clientIsGoogleBliss.value || client.clientIsGoogleYesly.value ||
                client.clientIsAlexaBliss.value || client.clientIsAlexaYesly.value);
        });

        const notificationTitle = ref('');
        const notificationSubTitle = ref('');
        if (client.clientIsGoogleYesly.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationGoogleTitle') as string;
            notificationSubTitle.value = i18n.t('accessConsentNotificationGoogleYeslySubTitle') as string;
        }
        else if (client.clientIsAlexaYesly.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationAlexaTitle') as string;
            notificationSubTitle.value = i18n.t('accessConsentNotificationAlexaYeslySubTitle') as string;
        }
        else if (client.clientIsGoogleBliss.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationGoogleTitle') as string;
            notificationSubTitle.value = i18n.t('accessConsentNotificationGoogleBlissSubTitle') as string;
        }
        else if (client.clientIsAlexaBliss.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationAlexaTitle') as string;
            notificationSubTitle.value = i18n.t('accessConsentNotificationAlexaBlissSubTitle') as string;
        }
        else {
            notificationTitle.value = i18n.t('accessConsentNotificationGenericTitle') as string;
            if (!showConsentScopesCheckboxList.value) {
                notificationSubTitle.value = i18n.t('accessConsentNotificationGenericSubTitle') as string;
            }
        }

        const clientId = route.value.query.client_id;
        const returnUrl = route.value.query.returnUrl;
        if (returnUrl) {
            store.dispatch('consentInfo', { returnUrl: returnUrl })
            .then(response => {
                if (response.result == 'OK') {
                    if (response.data.identityScopes) {
                        response.data.identityScopes.forEach(e => e['checked']=false);
                    }
                    if (response.data.resourceScopes) {
                        response.data.resourceScopes.forEach(e => e['checked']=false);
                    }

                    state.consentInfo = response.data;
                }
            });
        }

        const onAllow = async () => {
            let scopesConsented = [];
            if (showConsentScopesCheckboxList.value) {
                if (state.consentInfo.identityScopes) {
                    scopesConsented = scopesConsented.concat(state.consentInfo.identityScopes.filter(s => s.checked).map(s => s.name));
                }
                if (state.consentInfo.resourceScopes) {
                    scopesConsented = scopesConsented.concat(state.consentInfo.resourceScopes.filter(s => s.checked).map(s => s.name));
                }
            }
            else {
                scopesConsented = ['openid', 'api.v1.2.google-actions', 'api.v1.2.alexa-actions', 'offline_access', 'api.v1.2.ifttt-actions'];
            }
            if (returnUrl) {
                state.consentProgress = true;
                let response = await store.dispatch('consent', {
                    scopesConsented: scopesConsented,
                    returnUrl: returnUrl
                });
                state.consentProgress = false;
                if (response.result == 'OK') {
                    window.location.href = response.data.next;
                    return;
                }
            }
        }

        const onDeny = async () => {
            if (returnUrl) {
                state.consentProgress = true;
                let response = await store.dispatch('consent', {
                    scopesConsented: [], returnUrl: returnUrl
                });
                state.consentProgress = false;
                if (response.result == 'OK') {
                    window.location.href = response.data.next;
                    return;
                }
            }
        }

        const signinRoute = computed(() => {
            return { name: 'access-signin', query: route.value.query };
        });

        const consentScopeDisplayText = (consentScope) => {
            if (!consentScope.name) {
                return consentScope.displayName;
            }
            const key = `accessConsent${consentScope.name[0].toLocaleUpperCase()}${consentScope.name.substring(1)}`;
            return i18n.te(key) ? i18n.t(key) : consentScope.displayName;
        }

        const allowDisabled = computed(() => {
            if (showConsentScopesCheckboxList.value) {
                if (state.consentInfo && state.consentInfo.identityScopes &&
                    state.consentInfo.identityScopes.some(s => s.required && !s.checked)
                ) {
                    return true;
                }
                if (state.consentInfo && state.consentInfo.resourceScopes &&
                    state.consentInfo.resourceScopes.some(s => s.required && !s.checked)
                ) {
                    return true;
                }
            }
            return false;
        });

        const privacyPolicyHref = computed(() => getPrivacyPolicyLocalizedUrl(i18n.locale));

        return {
            state,
            onAllow,
            onDeny,
            notificationTitle,
            notificationSubTitle,
            signinRoute,
            consentScopeDisplayText,
            allowDisabled,
            showConsentScopesCheckboxList,
            privacyPolicyHref,
        }
    }
})
